import {
  getOwnerData,
  getQuotation,
} from 'app/services/businessFunctionHelpers';
import { handleOnChangeDataOwnerRenewal } from './helpers';
import { checkHasDataChangedForRenewal } from 'app/services/businessFunctions/helpers/checkHasDataChangedForRenewal';
import { setMainOwnerSelectionDictionary } from 'app/shared/helpers/setMainOwnerSelectionDictionary';

const onOwnerNameChange = {
  onOwnerNameChange(initialRun?: boolean) {
    const { name } = getOwnerData();
    const quotation = getQuotation();
    const { mainOwner } = quotation;

    const previousName = mainOwner?.name || '';

    if (checkHasDataChangedForRenewal(name, previousName)) {
      handleOnChangeDataOwnerRenewal(initialRun);
    }

    setMainOwnerSelectionDictionary();
  },
};

export default onOwnerNameChange;
